import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import axios from "axios";
import { API_URL1 } from "../services/url";
import { useAlert } from "react-alert";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { useNavigate } from "react-router-dom";


const AddTruck = () => {
  const navigate = useNavigate();
  const [brandModel, setBrandModel] = useState("");
  const [truckType, setTruckType] = useState([]);
  const [truck_type_id, setTrucktypeId] = useState("");
  const [registration_number, setRegistration_number] = useState("");
  const [color, setColor] = useState("");
  const [truck_number, setTruck_Number] = useState("");


  const [modelNo, setModelNo] = useState("");
  const [cap, setCap] = useState("");
  const [show, setShow] = useState(false);
  const alert = useAlert();
  const [btn_status, setbtn_Status] = useState("unclick");

  useEffect(() => {
    async function getTruck() {
      const res = await axios.get(`${API_URL1}trucker/truck/truckType`);
      return res;
    }

    getTruck().then((response) => setTruckType([...response.data.Truck_type]));
  }, []);

  const capacity = (e) => {
    setCap(e.target.value);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setbtn_Status("clicked");
    const truck = {
      truck_company_id: Number(localStorage.getItem("adminid")),
      brand_model: brandModel,
      vehicle_no: modelNo,
      capacity: cap,
      truck_type_id: Number(truck_type_id),
      registration_number: registration_number,
      color: color,
    };

    try {
      const response = await axios.post(`${API_URL1}trucker/truck`, truck, {
        headers: {
          "x-access-token": localStorage.getItem("TruckertokenKey"),
          "content-type": "application/json",
        },
      });

      alert.success(response.data.message, {
        onClose: () => {
          window.location = "/viewtruck";
        },
      });
    } catch (error) {
      alert.error("error");
    }
    setShow(false);
  };

  return (
    <>
    <TableContainer component={Paper} style={{ marginTop: '16px', width: '96%', marginLeft: 'auto', marginRight: 'auto', boxShadow: '0 0 0 rgba(0,0,0,0)', border: 'none' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 8, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', boxShadow: '0 8px 16px rgba(99,102,241,0.25)' }}>
            <LocalShippingIcon fontSize="small" />
          </div>
          <h1 style={{ margin: 0, fontWeight: 800, fontSize: 28, color: '#0f172a' }}>Add Truck</h1>
        </div>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/viewtruck')}
          style={{ padding: '10px 16px', color: '#ffffff', background: '#0f3b4a', border: 'none', borderRadius: 999, boxShadow: '0 6px 12px rgba(2,6,23,0.12)' }}
          onMouseEnter={(e)=>{ e.currentTarget.style.background='#114c65'; e.currentTarget.style.boxShadow='0 8px 16px rgba(2,6,23,0.18)'; e.currentTarget.style.transform='translateY(-1px)'; }}
          onMouseLeave={(e)=>{ e.currentTarget.style.background='#0f3b4a'; e.currentTarget.style.boxShadow='0 6px 12px rgba(2,6,23,0.12)'; e.currentTarget.style.transform='translateY(0)'; }}
        >Back</Button>
      </div>
    </TableContainer>
    <TableContainer component={Paper} style={{ marginTop: '8px', width: '96%', marginLeft: 'auto', marginRight: 'auto', marginBottom: '32px', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)' }} align="center">
      <Typography fontWeight="bold" variant="h6" color="initial" fontSize="20px" paddingBottom="12px" paddingTop="16px">Truck Details</Typography>
      <form onSubmit={handleAdd}>
        <Grid
          container
          spacing={3}
          sx={{
            padding: "0 5% 0 5%",
          }}
        >
          <Grid item xs={8} sm={4}>
            {" "}
            <Typography
              sx={{ mb: 1 }}
              align="left"
              fontSize="18px"
              fontWeight="bold"
            >
              Truck Number:{" "}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <TextField
              sx={{
                background: '#f8fafc',
                borderRadius: '12px!important',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: '#e5e7eb', borderRadius: '12px' },
                  '&:hover fieldset': { borderColor: '#cbd5e1' },
                  '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' }
                }
              }}
              size="small"
              border="none"
              required
              type="string"
              value={registration_number}
              onChange={(e) => setRegistration_number(e.target.value)}
              fullWidth
            ></TextField>
          </Grid>
          <Grid item xs={8} sm={4}></Grid>
          <Grid item xs={8} sm={4}>
            <Typography
              sx={{ mb: 1 }}
              fontSize="18px"
              fontWeight="bold"
              align="left"
            >
              Make:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            {" "}
            <TextField
              sx={{
                background: "#FFFFFF",
                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px!important",
              }}
              type="string"
              value={brandModel}
              onChange={(e) => setBrandModel(e.target.value)}
              required
              fullWidth
              size="small"
              border="none"
            ></TextField>
          </Grid>
          <Grid item xs={8} sm={4}></Grid>
          <Grid item xs={8} sm={4}>
            <Typography
              sx={{ mb: 1 }}
              fontSize="18px"
              fontWeight="bold"
              align="left"
            >
              Model Number:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            {" "}
            <TextField
              sx={{
                background: "#FFFFFF",
                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px!important",
              }}
              type="string"
              value={modelNo}
              onChange={(e) => setModelNo(e.target.value)}
              required
              fullWidth
              size="small"
              border="none"
            ></TextField>
          </Grid>
          <Grid item xs={8} sm={4}></Grid>
          {/* <Grid item xs={8} sm={4}>
            <Typography
              sx={{ mb: 1 }}
              fontSize="18px"
              fontWeight="bold"
              align="left"
            >
              Truck Number:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            {" "}
            <TextField
              sx={{
                background: "#FFFFFF",
                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px!important",
              }}
              type="string"
              value={truck_number}
              onChange={(e) => setTruck_Number(e.target.value)}
              required
              fullWidth
              size="small"
              border="none"
            ></TextField>
          </Grid>
          <Grid item xs={8} sm={4}></Grid> */}
          <Grid item xs={8} sm={4}>
            <Typography
              sx={{ mb: 1 }}
              align="left"
              fontSize="18px"
              fontWeight="bold"
            >
              Color:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <TextField
              sx={{
                background: '#f8fafc',
                borderRadius: '12px!important',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: '#e5e7eb', borderRadius: '12px' },
                  '&:hover fieldset': { borderColor: '#cbd5e1' },
                  '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' }
                }
              }}
              value={color}
              onChange={(e) => setColor(e.target.value)}
              size="small"
              border="none"
              required
              type="string"
              fullWidth
            ></TextField>
          </Grid>
          <Grid item xs={8} sm={4}></Grid>
          <Grid item xs={8} sm={4}>
            <Typography
              sx={{ mb: 1 }}
              align="left"
              fontSize="18px"
              fontWeight="bold"
            >
              Truck/Trail type:{" "}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              sx={{
                height: "41px",
                width: "100%!important",
                background: "#FFFFFF",
                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px!important",
                border: "none",
              }}
              required
              onChange={(e) => setTrucktypeId(e.target.value)}
              value={truck_type_id}
            >
              <MenuItem value="" disabled>
                {" "}
                Select Truck Type
              </MenuItem>
              {truckType.map((truck, key) => (
                <MenuItem
                  value={truck.truck_type_id}
                  key={key}
                  style={{ fontSize: "16px" }}
                >
                  {truck.type}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={8} sm={4}></Grid>{" "}
          <Grid item xs={8} sm={4}>
            <Typography
              sx={{ mb: 1 }}
              align="left"
              fontSize="18px"
              fontWeight="bold"
            >
              Max Tons Hauled:
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <TextField
              sx={{
                background: "#FFFFFF",
                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px!important",
                border: "none",
              }}
              size="small"
              border="none"
              required
              type="string"
              value={cap}
              onChange={capacity}
              fullWidth
            ></TextField>
          </Grid>
          <Grid item xs={8} sm={4}></Grid>
          <Grid item xs={8} sm={3}></Grid>{" "}
          <Grid item xs={8} sm={6}>
            <Button
              variant="contained"
              width="180px"
              type="submit"
              style={{ marginTop: '3%', padding: '12px 40px', background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', borderRadius: 999, boxShadow: '0 8px 16px rgba(99,102,241,0.25)' }}
              disabled={btn_status=="clicked"}
              onMouseEnter={(e)=>{ e.currentTarget.style.background='linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)'; e.currentTarget.style.boxShadow='0 10px 20px rgba(124,58,237,0.35)'; e.currentTarget.style.transform='translateY(-1px)'; }}
              onMouseLeave={(e)=>{ e.currentTarget.style.background='linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'; e.currentTarget.style.boxShadow='0 8px 16px rgba(99,102,241,0.25)'; e.currentTarget.style.transform='translateY(0)'; }}
            >
              <Typography color="white">Add Truck</Typography>
            </Button>
          </Grid>{" "}
          <Grid item xs={8} sm={3}></Grid>
        </Grid>
      </form>
    </TableContainer>
    </>
  );
};

export default AddTruck;
